import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";
import CreateKnowledgeService from "../../services/CreateKnowledgeService";
import VideoJS from "../VideoView/VideoView";
import { APICall } from "../../helpers/API/APICalls";
import { generateSignedPlaylistFile } from "../../constants/ApiEndpoints";

const VideoModal = (props) => {
  const { videoId, show, hide, viewVideoUrl, videoMetadata } = props;

  const [accountId, setAccountId] = useState("");
  const [location, setLocation] = useState("");
  const [token, setToken] = useState("");
  const [gcpVideoUrl, setGcpVideoUrl] = useState("");

  // const getData = async () => {
  //   if (videoId != null && videoId != "") {
  //     const id = getFromEncLocalStorage("accountId");
  //     const location = getFromEncLocalStorage("location");

  //     let vtoken = await CreateKnowledgeService.getVideoToken(videoId);
  //     setToken(vtoken);
  //     setAccountId(id);
  //     setLocation(location);
  //   }
  // };
  const generateSignedPlaylistFile1 = async () => {
    //setVideoLoading(true);
    try {
      console.log("🚀 ~ file: VideoModal.jsx:40 ~ generateSignedPlaylistFile1 ~ videoMetadata:", videoMetadata);
      console.log("🚀 ~ file: VideoModal.jsx:40 ~ generateSignedPlaylistFile1 ~ gcpVideoUrl:", gcpVideoUrl);
      if (!gcpVideoUrl && videoMetadata) {
        const request = { playlistContent: videoMetadata };

        const response = await APICall(generateSignedPlaylistFile, request);

        if (response?.data) {
          setGcpVideoUrl(response?.data);
        }
      }
    } catch (err) {
      console.log("🚀 ~ file: Video_view.js:103 ~ generateSignedPlaylistFile ~ err:", err);
    } finally {
      //setVideoLoading(false);
    }
  };

  useEffect(() => {
    console.log("🚀 ~ file: VideoModal.jsx:11 ~ VideoModal ~ videoMetadata:", videoMetadata);
    if (videoMetadata) {
      generateSignedPlaylistFile1();
    }
    // else if (viewVideoUrl == null && viewVideoUrl == "") {
    //   getData();
    // }
  }, [videoMetadata]);

  //let videoUrl = `https://api.videoindexer.ai/${location}/Accounts/${accountId}/Videos/${videoId}/PlayerWidget?accessToken=${token}`;

  console.log("gcpVideoUrl: ", gcpVideoUrl);

  return (
    <Modal show={show} backdrop="static" keyboard={false} size="lg" centered>
      <Modal.Header
        style={{
          background: "var(--theme-red)",
          padding: "10px",
          color: "white",
        }}
        onHide={() => hide()}
      >
        <div className="col-lg-12">Video</div>
      </Modal.Header>
      <Modal.Body>
        <p>
          {
            gcpVideoUrl && <VideoJS url={gcpVideoUrl} type="application/vnd.apple.mpegurl" height={"100%"} />
            // : viewVideoUrl != null && viewVideoUrl != "" ? (
            //   <video style={{ width: "100%", height: "auto", maxHeight: "300px" }} src={viewVideoUrl} controls></video>
            // ) : (
            //   <>
            //     <iframe
            //       loading="lazy"
            //       style={{ width: "100%", height: "var(--sidebar-width)" }}
            //       allowFullScreen
            //       controls="0"
            //       autoPlay="0"
            //       src={videoUrl}
            //       onContextMenu={(e) => e.preventDefault()}
            //     ></iframe>
            //   </>
            // )
          }
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-dark" style={{ marginLeft: 5 }} onClick={() => hide()}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default VideoModal;
